import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { confirmationAlert, showAlert } from '../../../utility/SweetAlert'

const InteractorMasterSubdistrictDelete = () => {
  const { t } = useTranslation()
  const subdistrictDelete = useCallback(
    (body, loading) => {
      const { uid, updated_by, subdistrict_name } = body
      const payload = {
        uid,
        updated_by,
      }
      confirmationAlert({
        message: `${t('message.confirm_delete')} ${subdistrict_name} ?`,
        icon: 'question',
      }).then(result => {
        if (result === true) {
          ApiService.jsonRequest('/master-subdistrict/delete', payload, response => {
            loading(false)
            if (response.status_code === 200) {
              showAlert({
                icon: 'success',
                message: t('message.successfully_deleted'),
                timer: 1500,
                redirect: '/master/subdistrict/manage',
              })
            } else {
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.messages}`),
                timer: 1500,
              })
            }
          })
        }
      })
    },
    [t],
  )
  return { subdistrictDelete }
}

export default InteractorMasterSubdistrictDelete
